import React, { useEffect, useState } from "react";
import CrudTable from "../components/CrudTable";
import { api } from "../lib/api";

const columns = [
  { key: "claim_id", label: "Claim ID" },
  { key: "description", label: "Description" },
  { key: "approval_status", label: "Approval", status: true },
  { key: "warranty_status", label: "Warranty", status: true },
];

export default function Warranty() {
  const [brands, setBrands] = useState([]); const [outlets, setOutlets] = useState([]);
  const [mfrs, setMfrs] = useState([]); const [assets, setAssets] = useState([]);
  useEffect(() => {
    api.get("/brands", { params: { limit: 200 } }).then((r) => setBrands(r.data.items));
    api.get("/outlets", { params: { limit: 500 } }).then((r) => setOutlets(r.data.items));
    api.get("/manufacturers", { params: { limit: 200 } }).then((r) => setMfrs(r.data.items));
    api.get("/assets", { params: { limit: 500 } }).then((r) => setAssets(r.data.items));
  }, []);
  const formFields = [
    { name: "asset_id", label: "Asset", type: "select", required: true, options: assets.map((a) => ({ value: a.id, label: a.serial_number })) },
    { name: "manufacturer_id", label: "Manufacturer", type: "select", required: true, options: mfrs.map((m) => ({ value: m.id, label: m.name })) },
    { name: "brand_id", label: "Brand", type: "select", required: true, options: brands.map((b) => ({ value: b.id, label: b.name })) },
    { name: "outlet_id", label: "Outlet", type: "select", required: true, options: outlets.map((o) => ({ value: o.id, label: o.name })) },
    { name: "description", label: "Claim Description", required: true, wide: true },
    { name: "approval_status", label: "Approval Status", type: "select", default: "pending",
      options: [{ value: "pending", label: "Pending" }, { value: "approved", label: "Approved" }, { value: "rejected", label: "Rejected" }] },
    { name: "warranty_status", label: "Warranty Status", type: "select", default: "under_warranty",
      options: [{ value: "under_warranty", label: "Under Warranty" }, { value: "expired", label: "Expired" }] },
  ];
  return <CrudTable title="Warranty Claims" description="Review, approve and dispatch warranty replacements." endpoint="/warranty" columns={columns} formFields={formFields} />;
}
